<template>
  <div class="productList" ref="container" v-cloak>
    <swiper class="swiper-wrapper" :options="IntegralShopBanner">
      <swiper-slide
        class="swiper-slide"
        v-for="(item, index) in banner"
        :key="index"
      >
        <div class="slide-image">
          <img :src="item.img" class="video_play" />
        </div>
      </swiper-slide>
    </swiper>
    <div class="blackbg"></div>
    <div class="nav-box-box">
      <div class="nav-box">
        <router-link class="nav-item" :to="{ path: '/user/integral' }">
          <div class="nav-item-img">
            <img src="@assets/images/i_nav2.png" />
          </div>
          <div class="nav-item-title">我的积分</div>
        </router-link>
        <router-link class="nav-item" :to="{ path: '/user/sign' }">
          <div class="nav-item-img">
            <img src="@assets/images/i_nav1.png" />
          </div>
          <div class="nav-item-title">每日签到</div>
        </router-link>
        <router-link class="nav-item" :to="{ path: '/integralOrder/list/0' }">
          <div class="nav-item-img">
            <img src="@assets/images/i_nav3.png" />
          </div>
          <div class="nav-item-title">兑换记录</div>
        </router-link>
      </div>
    </div>
    <div class="graybg"></div>
    <div class="list-title">
      <div class="title">大家都在换</div>
      <router-link class="list-button" :to="{ path: '/user/integralGoodList' }">
        查看更多<span
          class="iconfont jt icon-jiantou"
        ></span>
      </router-link>
    </div>
    <div
      class="list acea-row row-between-wrapper"
      :class="Switch === true ? '' : 'on'"
      ref="container"
    >
      <div
        @click="goDetail(item)"
        v-for="(item, index) in productList"
        :key="index"
        class="item"
        :class="Switch === true ? '' : 'on'"
        :title="item.store_name"
      >
        <div class="pictrue" :class="Switch === true ? '' : 'on'">
          <img :src="item.image" :class="Switch === true ? '' : 'on'" />
        </div>
        <div class="text" :class="Switch === true ? '' : 'on'">
          <div class="name line1">{{ item.store_name }}</div>
          <div
            class="money font-color-red"
            :class="Switch === true ? '' : 'on'"
          >
            <span class="num">{{ item.price }}</span
            >&nbsp;积分
          </div>
          <div
            class="vip acea-row row-between-wrapper"
            :class="Switch === true ? '' : 'on'"
          >
            <div>{{ item.sales }}人兑换</div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loadend" :loading="loading"></Loading>
    <div
      class="noCommodity"
      v-cloak
      style="background-color: #fff"
      v-if="productList.length === 0 && where.page > 1"
    >
      <div class="noPictrue">
        <img src="@assets/images/noGood.png" class="image" />
      </div>
      <recommend>
        <Loading :loaded="loadend" :loading="loading"></Loading>
      </recommend>
    </div>
  </div>
</template>

<script>
import Recommend from "@components/Recommend";
import { getIntegralproducts, getIntegralGroomList } from "@api/store";
import debounce from "lodash.debounce";
import Loading from "@components/Loading";
import { goShopDetail } from "@libs/order";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "GoodsList",
  components: {
    Recommend,
    Loading,
    swiper,
    swiperSlide,
  },

  props: {},
  data: function () {
    const { s = "", id = 0, title = "" } = this.$route.query;

    return {
      IntegralShopBanner: {
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        autoplayDisableOnInteraction: false, // 这样，即使我们滑动之后， 定时器也不会被清除
      },
      banner: [],
      hostProduct: [],
      productList: [],
      Switch: true,
      where: {
        page: 1,
        limit: 4,
        keyword: s,
        sid: id, //二级分类id
        news: 0,
        priceOrder: "",
        salesOrder: "",
      },
      title: title && id ? title : "",
      loadTitle: "",
      loading: false,
      loadend: false,
      price: 0,
      stock: 0,
      nows: false,
    };
  },
  watch: {
    title() {
      this.updateTitle();
    },
    $route(to) {
      if (to.name !== "GoodsList") return;
      const { s = "", id = 0, title = "" } = to.query;

      if (s !== this.where.keyword || id !== this.where.sid) {
        this.where.keyword = s;
        this.loadend = false;
        this.loading = false;
        this.where.page = 1;
        this.where.sid = id;
        this.title = title && id ? title : "";
        this.nows = false;
        this.$set(this, "productList", []);
        this.price = 0;
        this.stock = 0;
        this.get_product_list();
      }
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted: function () {
    this.updateTitle();
    this.get_product_list();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.get_product_list();
    });
  },
  methods: {
    // 商品详情跳转
    goDetail(item) {
      goShopDetail(item).then(() => {
        this.$router.push({ path: "/integralGoodCon/" + item.id });
      });
    },
    updateTitle() {
      document.title = this.title || this.$route.meta.title;
    },
    get_product_list: debounce(function () {
      var that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      this.setWhere();
      getIntegralGroomList(1).then((res) => {
        this.banner = res.data.banner;
        this.productList = res.data.list;
        that.loading = false;
        that.loadend = res.data.length < that.where.limit; //判断所有数据是否加载完成；
        that.where.page = that.where.page + 1;
      });
    }, 300),
    submitForm: function () {
      this.$set(this, "productList", []);
      this.where.page = 1;
      this.loadend = false;
      this.loading = false;
      this.get_product_list();
    },
    //点击事件处理
    set_where: function (index) {
      let that = this;
      switch (index) {
        case 0:
          return that.$router.push({ path: "/category" });
        case 1:
          if (that.price === 0) that.price = 1;
          else if (that.price === 1) that.price = 2;
          else if (that.price === 2) that.price = 0;
          that.stock = 0;
          break;
        case 2:
          if (that.stock === 0) that.stock = 1;
          else if (that.stock === 1) that.stock = 2;
          else if (that.stock === 2) that.stock = 0;
          that.price = 0;
          break;
        case 3:
          that.nows = !that.nows;
          break;
        default:
          break;
      }
      that.$set(that, "productList", []);
      that.where.page = 1;
      that.loadend = false;
      that.get_product_list();
    },
    //设置where条件
    setWhere: function () {
      let that = this;
      if (that.price === 0) {
        that.where.priceOrder = "";
      } else if (that.price === 1) {
        that.where.priceOrder = "asc";
      } else if (that.price === 2) {
        that.where.priceOrder = "desc";
      }
      if (that.stock === 0) {
        that.where.salesOrder = "";
      } else if (that.stock === 1) {
        that.where.salesOrder = "asc";
      } else if (that.stock === 2) {
        that.where.salesOrder = "desc";
      }
      that.where.news = that.nows ? "1" : "0";
    },
    switchTap: function () {
      let that = this;
      that.Switch = !that.Switch;
    },
  },
};
</script>
<style scoped>
.productList {
  background: #fff;
  position: relative;
}
.blackbg {
  position: absolute;
  width: 100%;
  top: 0;
  height: 100px;
  background: #000;
}
.blackbg::after {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -0.98rem;
  content: "";
  height: 1rem;
  width: 100%;
  border-radius: 0 0 50% 50%;
  background-color: #000000;
}
.productList .swiper-wrapper {
  width: 90%;
  padding: 0.3rem 0 0.2rem 0;
  height: 150px;
  border-radius: 8px;
}
.bt-list-title {
}
.bt-list-title .title {
  width: 100%;
  padding: 0 0.2rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  background: #fff;
  line-height: 3;
}
.bt-list-title .item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.2rem;
}
.bt-list-title .item .item-left-box {
  display: flex;
  align-items: center;
}
.bt-list-title .item .item-left-box img {
  padding: 0 0.1rem;
}
.bt-list-title .item .item-left-box .left-box-info {
}
.bt-list-title .item .item-left-box .left-box-info .left-box-title {
  font-size: 0.28rem;
  font-weight: 700;
}
.bt-list-title .item .item-left-box .left-box-info .left-box-title-des {
  font-size: 0.24rem;
  color: #999;
}
.bt-list-title .item .item-right-box {
  background: #c9975c;
  color: #fff;
  padding: 0.1rem 0.16rem;
  border-radius: 8px;
}
.noCommodity {
  border-top: 3px solid #f5f5f5;
  padding-bottom: 1px;
}
.nav-box-box {
  padding: 0 0 0.2rem 0;
  background: #fff;
}
.nav-box {
  width: 90%;
  padding: 0.15rem 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0.01rem 0.01rem 0.1rem #dcdbdb;
}
.nav-box .nav-item {
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.nav-box .nav-item .nav-item-img {
  width: 100%;
  text-align: center;
}
.nav-box .nav-item .nav-item-img img {
  width: 50%;
}
.nav-box .nav-item .nav-item-title {
  text-align: center;
  line-height: 2;
  color: #333;
}

[v-cloak] {
  display: none;
}
.index {
  background-color: #fff;
}

.index .follow {
  z-index: 100000;
}
.keep {
  text-align: center;
}
.slide-image {
  width: 100%;
  height: 100%;
}

.slide-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.list-title {
  width: 100%;
  padding: 0 0.2rem;
  display: flex;
  justify-content: space-between;
  background: #fff;
  line-height: 3;
}
.list-title .title {
  color: #333;
  font-size: 0.32rem;
  font-weight: 700;
}
.list-title .list-button {
  color: #999;
  display: block;
  font-size: 0.26rem;
  font-weight: 300;
  line-height: 0.9rem;
}
.productList .list {
  background: #fff;
  margin-top: 0;
  padding: 0 0.2rem 0.2rem;
}
.productList .list .item {
  box-shadow: 0.01rem 0.01rem 0.1rem #dcdbdb;
}
.swiper-slide {
  border-radius: 8px;
  overflow: hidden;
}
.graybg {
  background: #f7f7f7;
  height: 15px;
}
.jt {
  font-size: 0.26rem;
  line-height: 0.9rem;
}
</style>
